import styled from "styled-components";
import ButtonLoading from "../../../components/buttonLoading";

export const DivTitle = styled.div`
  display: flex;
  align-items: start;
  margin-left: 30px;
  margin-bottom: 20px;
`;

export const DivFormInputs = styled.div`
  display: flex;
  gap: 76px;
  flex-direction: row;
  align-items: start;
  margin-left: 50px;
  margin-right: 50px;
`;
export const DivButton = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: 2vh;
  border-top: 3px solid #1f299c;
`;
export const ButtonCancel = styled(ButtonLoading)`
  order: 2;
  width: 104px;
  height: 30px;

  && {
    color: white;
    background-color: #fe4c01;
    font-size: 12px;

    :hover {
      background-color: #bb4108;
    }
  }
`;
export const ButtonCreate = styled(ButtonLoading)`
  order: 2;
  width: 130px;
  min-width: 130px;
  height: 44px;

  && {
    color: white;
    background-color: #1f299c;
    font-size: 12px;
    :hover {
      background-color: #0665ff;
    }
  }
`;

